__turbopack_context__.v({
  "emptyStateWrapper": "EmptyZapsState-module__nAkU-a__emptyStateWrapper",
  "gridWrapper": "EmptyZapsState-module__nAkU-a__gridWrapper",
});
